import { Fragment, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Container } from '@leroy-merlin-br/backyard-react-ui'

import { error, success } from 'scripts/utils/message'

import { useProfileAndRegions } from 'lmcv/hooks/use-profile-regions'
import { updateProfile } from 'lmcv/services/profile'
import { getSignUpInformation } from 'lmcv/services/signUpInformation'
import { schemas } from 'lmcv/modules/schemas'
import DocumentPro from 'lmcv/components/DocumentPro'

import { Form, FormSkeleton } from './components/Form'
import * as S from './styled'

const SignUpPage = ({ loyaltyPro }) => {
  const [data, loading, profileError] = useProfileAndRegions()
  const [region, setRegions] = useState('')
  const [signUpInformation, setSignUpInformation] = useState('')
  const [classOccupation, setClassOccupation] = useState('')
  const [isLoyaltyPro, setLoyaltyPro] = useState(JSON.parse(loyaltyPro))
  const [isLoadingForm, setIsLoadingForm] = useState(false)

  useEffect(() => {
    setRegions(data.profile?.regionSlug)
    getOccupations(data.profile?.regionSlug)
  }, [data])

  const onRegionChange = (data) => {
    setRegions(data)
    getOccupations(data)
  }

  const getOccupations = async (region) => {
    if (region) {
      const { data } = await getSignUpInformation(region)
      setSignUpInformation({ ...data })
    }
  }

  const redirectUser = () => {
    window.setTimeout(() => {
      location.href = '/fidelidade'
    }, 1000)
  }

  const redirectUserError = () => {
    location.href = '/404'
  }

  const onSubmit = (dataForm, e) => {
    e.preventDefault()
    setIsLoadingForm(true)
    updateProfile(schemas.completeRegister(dataForm))
      .then(({ data }) => {
        setIsLoadingForm(false)
        if (isLoyaltyPro && data.needDocumentation) {
          return setClassOccupation(dataForm.occupation)
        }

        success(
          'Seu cadastro foi completado com sucesso, aguarde enquanto direcionamos você para o programa!'
        )

        redirectUser()
      })
      .catch((e) => {
        setIsLoadingForm(false)
        error(
          'Não foi possivel concluir o seu cadastro no Programa Fidelidade da Leroy Merlin, tente novamente mais tarde!'
        )
      })
  }

  return (
    <Fragment>
      <S.CoverBackground />
      <Container>
        <S.Content>
          <S.Title size="mega">
            Complete seu cadastro para participar do programa de fidelidade
          </S.Title>
          <S.Description size="kilo">
            Para criar uma experiência personalizada para o seu perfil
            precisamos de mais algumas informações
          </S.Description>

          {loading
            ? (
            <FormSkeleton />
              )
            : (
            <Form
              initialState={data.profile}
              regions={data.regions}
              stores={signUpInformation.stores}
              occupations={signUpInformation.occupations}
              onRegionChange={onRegionChange}
              onSubmit={onSubmit}
              loading={isLoadingForm}
              isLoyaltyPro={isLoyaltyPro}
            />
              )}

          {!loading && profileError && redirectUserError()}
        </S.Content>
      </Container>

      {isLoyaltyPro && (
        <DocumentPro
          open={classOccupation !== ''}
          classOccupation={classOccupation}
          onFinish={redirectUser}
          onCancel={redirectUser}
        />
      )}
    </Fragment>
  )
}

SignUpPage.propTypes = {
  loyaltyPro: PropTypes.string
}

export default SignUpPage
